import { Controller } from '@hotwired/stimulus';
import type { NotificationType } from '@shared/script/enums/notification';
import { statusClassMap } from '@shared/script/enums/notification';
import { subscribeEvent, unsubscribeEvent } from '@shared/script/eventDispatcher';

type EventDetail = {
    type?: keyof typeof NotificationType
}

export default class extends Controller {
    connect(): void {
        subscribeEvent('notifications:show', this.show.bind(this));
        subscribeEvent('notifications:hide', this.hide.bind(this));
        subscribeEvent('notifications:hideAll', this.hideAll.bind(this));
    }

    disconnect(): void {
        unsubscribeEvent('notifications:show', this.show.bind(this));
        unsubscribeEvent('notifications:hide', this.hide.bind(this));
        unsubscribeEvent('notifications:hideAll', this.hideAll.bind(this));

    }

    notificationClassName(type: NotificationType): string {
        if (typeof statusClassMap[type] === 'string') {
            return `.notification--${statusClassMap[type]}`;
        } else if (typeof statusClassMap[type] === 'object') {
            return statusClassMap[type].reduce((className, t) => {
                return className += `.notification--${t}`;
            }, '');
        }
    }

    show(type: string): void {
        const notification = this.element.querySelector(this.notificationClassName(type));
        notification && notification.classList.remove('hidden');
    }

    hide(type: string): void {
        const notification = this.element.querySelector(this.notificationClassName(type));
        notification && notification.classList.add('hidden');
    }

    hideAll(): void {
        const notifications: HTMLElement[] = this.element.querySelectorAll('.notification');
        notifications.forEach(notification => this.hide(notification.dataset.type));
    }

    handleNotifyEvent(event: CustomEvent<EventDetail>): void {
        this.hideAll();

        const { type = null } = event.detail;
        type !== null && this.show(type);
    }
}
